<script>
import AppIconBase from "./AppIconBase.vue";
export default {
  components: {
    AppIconBase,
  },
  data() {
    return {
      isVisible: true,
    };
  },
  props: {
    content: {
      type: Object,
      required: true,
    },
  },
};
</script>
<template>
  <transition name="fade" appear>
    <div v-show="isVisible" class="announce">
      {{ `${content.copy}&nbsp;` }}
      <a :href="content.link">{{ content.linkText }}</a>

      <AppIconBase
        @click.native="isVisible = !isVisible"
        name="CloseIcon"
        class="icon"
      />
    </div>
  </transition>
</template>

<style lang="scss" scoped>
@import "../styles/01-settings/breakpoints";
@import "../styles/01-settings/mq";

.announce {
  display: none;
}

@include mq($from: md) {
  .announce {
    --size: 16px;
    align-items: center;
    background-color: var(--color-accent-1);
    border-radius: 21px;
    color: var(--secondary);
    display: flex;
    font-size: 13px;
    height: var(--pillHeight);
    justify-content: center;
    left: 0;
    margin-left: auto;
    margin-right: auto;
    margin: 0 auto;
    padding: 0 50px;
    position: absolute;
    right: 0;
    top: 20px;
    width: max-content;
    z-index: 3000;
  }
  .announce a {
    color: var(--secondary);
    font-weight: 500;
    font-size: 13px;
  }
}

.icon {
  width: var(--size);
  height: var(--size);
  position: absolute;
  right: 20px;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  transform-origin: center center;
  :hover {
    transform-origin: center center;
    transform: rotate(2rad);
  }
}
@include mq($from: xl) {
  .announce {
    width: max-content;
    // max-width: var(--max-cont-w);
  }
}
</style>



// WEBPACK FOOTER //
// resources/assets/vuejs/frontend/2023-launch/components/AnnouncementBanner.vue